import { render, staticRenderFns } from "./TextAvatar.vue?vue&type=template&id=474ad905&scoped=true"
import script from "./TextAvatar.vue?vue&type=script&lang=js"
export * from "./TextAvatar.vue?vue&type=script&lang=js"
import style0 from "./TextAvatar.vue?vue&type=style&index=0&id=474ad905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474ad905",
  null
  
)

export default component.exports